import { Avatar } from '@material-ui/core'
import defaultAvatar from 'assets/img/default-avatar.png'
import * as React from 'react'
import ReactFileReader from 'react-file-reader'
import './style.scss'

export interface IProps {
  name: string
  avatar: string
  handleFiles: any
  image: string | null
}

export interface IProps {}

export interface IState {}

export default class Content extends React.PureComponent<IProps, IState> {
  render() {
    const { name, avatar, handleFiles, image } = this.props
    return (
      <div className="parent-profile-content mobile-container">
        <div className="top-info">
          <div className="parent-avatar">
            <ReactFileReader handleFiles={handleFiles} base64={true}>
              <React.Fragment>
                <div className="logo">
                  <div className="wrapper">
                    <Avatar
                      src={
                        image
                          ? URL.createObjectURL(image)
                          : avatar || defaultAvatar
                      }
                      className={`avatar ${image ? 'active' : undefined}`}
                    />
                  </div>
                </div>
                {image ? undefined : <div className="add-button" />}
              </React.Fragment>
            </ReactFileReader>

            <div className="status online" />
          </div>
          <div className="parent-name-wrapper">
            <div className="parent-name">{name}</div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/ParentProfile/content.tsx